/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AMCActions } from 'src/Redux';
import { Container, ContentLoader, ContentNoData } from 'src/Components';
import { i18, trb } from 'src/Utilities';
import { UserLimits, UserSelect } from './Components';
import { Typography } from '../../../../shared';

export const SettingsAccountsLimitsV2 = () => {
  const dispatch = useDispatch();

  const { managedUsers, sendManagedUsers } = useSelector((state: any) => state.AMCReducers);

  useEffect(() => {
    if (!managedUsers && !sendManagedUsers) {
      dispatch((AMCActions as any).getManagedUsers());
    }
    return () => {
      dispatch((AMCActions as any).clearUserLimits());
    };
  }, []);

  if (sendManagedUsers) {
    return <ContentLoader />;
  }

  return (
    <div>
      <Typography.Title
        level={1}
        style={{ fontSize: '1rem', marginBottom: '20px' }}
        className="eb_content_subtitle fw-normal"
      >
        {trb(i18.ContentTitles.SettingsAccountsLimits)}
      </Typography.Title>

      {!managedUsers ? (
        <ContentNoData id="managedUsers" />
      ) : (
        <Container>
          <UserSelect />
          <UserLimits />
        </Container>
      )}
    </div>
  );
};
